import { CampaignCreateParams } from '../../../types'
import { UseFormReturn, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import TileGrid, { TileOption } from './TileGrid'
import { CampaignsIcon, JourneysIcon } from '../../../ui/icons'

interface CampaignTypeTilesProps {
    form: UseFormReturn<CampaignCreateParams>
}

export default function CampaignTypeTiles({ form }: CampaignTypeTilesProps) {
    const { t } = useTranslation()
    const value = useWatch({
        control: form.control,
        name: 'type',
    })

    const options: TileOption[] = [
        {
            value: 'blast',
            content: (
                <>
                    <div className="tile-type-icon"><CampaignsIcon /></div>
                    <div className="tile-type-text">
                        <span className="tile-name">{t('campaign_type_blast')}</span>
                        <span className="tile-desc">{t('wizard_type_blast_desc')}</span>
                    </div>
                </>
            ),
        },
        {
            value: 'trigger',
            content: (
                <>
                    <div className="tile-type-icon"><JourneysIcon /></div>
                    <div className="tile-type-text">
                        <span className="tile-name">{t('campaign_type_trigger')}</span>
                        <span className="tile-desc">{t('wizard_type_trigger_desc')}</span>
                    </div>
                </>
            ),
        },
    ]

    return (
        <TileGrid
            label={t('wizard_type_label')}
            required
            columns={2}
            value={value}
            onChange={(v) => form.setValue('type', v as 'blast' | 'trigger')}
            options={options}
            className="tile-grid-type"
        />
    )
}
